// Handles taps on an event's underlying venue chip. The event's venue may
// live outside the current map viewport / filters, so it may not be in
// `sortedVenues` yet. We:
//   1. Look up the venue in `allVenues`; if missing, hydrate on demand
//      via /api/venues/{id} (venues outside operating hours are hidden by
//      the list endpoint but their events still surface).
//   2. Pin + expand the venue so `sortedVenues` includes it.
//   3. Scroll the list to reveal the newly expanded card.

import { useCallback } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export function useEventVenueTap({
  allVenues,
  setAllVenues,
  setPinnedVenueId,
  setExpandedVenueId,
  venueListRef,
}) {
  const onEventVenueTap = useCallback(async (venueId) => {
    if (!venueId) return;
    let venueInList = allVenues.some((v) => v.id === venueId);
    if (!venueInList) {
      try {
        const res = await axios.get(`${API}/venues/${venueId}`);
        if (res.data && res.data.id) {
          setAllVenues((prev) => (
            prev.some((v) => v.id === res.data.id) ? prev : [...prev, res.data]
          ));
          venueInList = true;
        }
      } catch (err) {
        console.error('Failed to hydrate closed venue from event tap:', err);
        return;
      }
    }
    if (venueInList) setPinnedVenueId(venueId);
    setExpandedVenueId(venueId);
    setTimeout(() => {
      venueListRef.current?.scrollToVenue(venueId);
    }, 360);
  }, [allVenues, setAllVenues, setPinnedVenueId, setExpandedVenueId, venueListRef]);

  return onEventVenueTap;
}
